(function () {
    'use strict';
    angular.module('tmx-app')
        .controller('loanProductEditCtrl', ['$scope', 'resolvedData', '$state', '$filter', 'LoanProductService', 'tmxUtility', 'ToastService',

            function LoanProductEditCtrl($scope, resolvedData, $state, $filter, LoanProductService, tmxUtility, ToastService) {
                /////////////////INITIALIZATIONS///////////////////////////////////////////////////////////////////////////////////////
                var loanProductVM = this;
                $scope.dataLoading = false;
                loanProductVM.lookup = {};
                loanProductVM.readonly = false;
                loanProductVM.statusLookup = [
                    {
                        LookupId: '1',
                        VisibleValue: 'Active'
                    },
                    {
                        LookupId: '0',
                        VisibleValue: 'Inactive'
                    }
                ];

                ///////////////////////CANCEL BUTTON FORM AT ANY TIME//////////////////////////////////////////////////////////////////
                loanProductVM.cancel = function () {
                    loanProductVM.LoanProduct = {};//reset the role information
                    $state.searchClear = true;
                    $state.go("^");
                };

                /////////////////////////////GET PRODUCTSTATUS ACCORDING TO EFFECTIVE END AND START DATE/////////////////////////////
                loanProductVM.getStatus = function (dataitem) {
                    var currentDate = new Date();
                    var startDate = kendo.parseDate(dataitem.EffectiveStartDate);
                    var endDate = kendo.parseDate(dataitem.EffectiveEndDate);
                    if (((endDate - currentDate) >= 0) && ((startDate - currentDate) <= 0))
                        return 'Active';
                    else
                        return 'Inactive';
                };
                ////////////////////////////////GET LOAN TYPE FROM LOOKUP SERVICE/////////////////////////////////////////////////////
                loanProductVM.getLoanType = function (dataitem) {
                    if (angular.isDefined(LoanProductService.lookup.types) && LoanProductService.lookup.types.length > 0) {
                        for (var i = LoanProductService.lookup.types.length - 1; i >= 0; i--) {
                            if (LoanProductService.lookup.types[i].LookupId == dataitem.ProductTypeLkp) {
                                return LoanProductService.lookup.types[i].VisibleValue;
                            }
                        }
                    }
                    return "none";
                };
                loanProductVM.getProductType = function (dataitem) {
                    if (angular.isDefined(LoanProductService.lookup.types) && LoanProductService.lookup.types.length > 0) {
                        for (var i = LoanProductService.lookup.types.length - 1; i >= 0; i--) {
                            if (LoanProductService.lookup.types[i].LookupId == dataitem.ProductTypeLkp) {
                                return LoanProductService.lookup.types[i].VisibleValue;
                            }
                        }
                    }
                    //return "none";
                    return dataitem.ProductTypeLkp;
                };

                loanProductVM.getProductClassification = function (dataitem) {                    
                    if (angular.isDefined(LoanProductService.lookup.types) && LoanProductService.lookup.types.length > 0) {
                        for (var i = LoanProductService.lookup.types.length - 1; i >= 0; i--) {
                            if (LoanProductService.lookup.types[i].LookupId == dataitem.ProductTypeLkp) {
                                return LoanProductService.lookup.types[i].VisibleValue;
                            }
                        }
                    }                    
                    return dataitem.ProductClassificationLkp;
                };
                ////////////////////////////////GET REPAYMENT FREQUENCY FROM LOOKUP SERVICE/////////////////////////////////////////////
                loanProductVM.getRepaymentFreq = function (dataitem) {
                    if (angular.isDefined(LoanProductService.lookup.repaymentFreq) && LoanProductService.lookup.repaymentFreq.length > 0) {
                        for (var i = LoanProductService.lookup.repaymentFreq.length - 1; i >= 0; i--) {
                            if (LoanProductService.lookup.repaymentFreq[i].LookupId == dataitem.RepaymentFrequencyLkp) {
                                return LoanProductService.lookup.repaymentFreq[i].VisibleValue;
                            }
                        }
                    }
                    return "none";
                };
                ////////////////////////////////GET REPAYMENT FREQUENCY FROM LOOKUP SERVICE/////////////////////////////////////////////
                loanProductVM.isGroup = function () {
                    if (angular.isDefined(loanProductVM.LoanProduct)) {

                        if (loanProductVM.LoanProduct.ProductTypeLkp == 165) { //GROUP TYPE and LENDING METHODOLOGY
                            return true;
                        }
                        else { //INDIVIDUAL TYPE and LENDING METHODOLOGY

                            return false;
                        }
                    }
                    return false;
                };

                loanProductVM.onStartDateSelected = function (selectedDate) {
                    if (selectedDate != null) {

                        loanProductVM.LoanProduct.EffectiveStartDate = new Date(moment(new Date(selectedDate)).startOf('day').toDate().toJSON());//start Date
                        loanProductVM.StartDateInvalid = false;
                        loanProductVM.minEndDate = loanProductVM.vm.EffectiveStartDate;//ensuring that end date >= start Date
                    }
                    else {
                        loanProductVM.StartDateInvalid = true;
                    }
                };
                ///////////////////////////////DATE END SELECTION /////////////////////////////////////////////////////////////////////
                loanProductVM.onEndDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        loanProductVM.LoanProduct.EffectiveEndDate = new Date(moment(new Date(selectedDate)).endOf('day').toDate().toJSON());//start Date
                        loanProductVM.EndDateInvalid = false;
                    }
                    else {
                        loanProductVM.EndDateInvalid = true;
                    }
                };

                loanProductVM.addParameter = function () {
                    let bp = {
                        ProductParameterId: 0,
                        CompanyBranchId: loanProductVM.LoanProduct.ProductId,
                        ProductParameterName: '',
                        ProductParameterValue: '',
                        IsActive: 1
                    };
                    loanProductVM.LoanProduct.TmxProductParameters.push(bp);
                };

                loanProductVM.removeParameter = function (index) {
                    loanProductVM.LoanProduct.TmxProductParameters.splice(index, 1);
                };

                loanProductVM.save = function (form) {
                    if (form.$invalid) {
                        SetTouched(form);
                        var displayMsg = $filter('translate')("CorrectInvalidFields");
                        ToastService.showCustomToast("error", displayMsg);
                        return;
                    }
                    $scope.dataLoading = true;
                    loanProductVM.LoanProduct.TmxProductCycle = null;
                    loanProductVM.sendData = angular.copy(loanProductVM.LoanProduct);
                    loanProductVM.sendData.$saveOrUpdate().then(function (promise) {
                        $scope.dataLoading = false;
                        if (tmxUtility.exists(promise)) {
                            if (promise.status.code >= 400) {
                                loanProductVM.formSubmitted = false;
                                var displayMsg = "";
                                if (angular.isDefined(promise.data.ModelState)) {
                                    var models = Object.keys(promise.data.ModelState);
                                    models.forEach(function (key) {
                                        displayMsg += (promise.data.ModelState[key])
                                    });
                                }
                                else {
                                    displayMsg = promise.data.Message;
                                }
                                ToastService.showCustomToast("error", displayMsg);
                            }
                            else {
                                $state.searchClear = true;
                                $state.go("^");
                                ToastService.showCustomToast("success",$filter('translate')('DataSaveSuccess'));

                            }
                        } 
                        else
                            ToastService.showCustomToast("error",$filter('translate')('SaveError'));
                    });
                }


                //#region ================== Private Methods =======================

                function HandleResolveData() {
                    if (angular.isDefined(resolvedData.LoanProduct.data)) {
                        loanProductVM.LoanProduct = resolvedData.LoanProduct.data; //list of LoanProduct Data populated
                        loanProductVM.LoanProduct.Status = loanProductVM.getStatus(loanProductVM.LoanProduct);
                        loanProductVM.LoanProduct.ProductType = loanProductVM.getProductType(loanProductVM.LoanProduct);
                        loanProductVM.LoanProduct.RepaymentFrequency = loanProductVM.getRepaymentFreq(loanProductVM.LoanProduct);
                        loanProductVM.LoanProduct.LendingMethodology = loanProductVM.getLoanType(loanProductVM.LoanProduct);//same as Loan Type for now
                        loanProductVM.LoanProduct.ProductClassificationLkp = loanProductVM.getProductClassification(loanProductVM.LoanProduct);
                        if (!loanProductVM.isGroup()) {
                            loanProductVM.LoanProduct.MinGrpMembers = 1;
                            loanProductVM.LoanProduct.MaxGrpMembers = 1;
                        }
                        if (!tmxUtility.exists(loanProductVM.LoanProduct.TmxProductParameters)) {
                            loanProductVM.LoanProduct.TmxBranchParameters = [];
                        }
                    }
                }
                function SetTouched(form) {
                    angular.forEach(form, function (value) {
                        if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid)) {
                            value.$setTouched();
                        }
                    });
                }

                function InitializeData() {
                    if (loanProductVM.LoanProduct.EffectiveStartDate > new Date()) {
                        loanProductVM.StartDateReadonly = false;
                        loanProductVM.minStartDate = moment(new Date()).endOf('day').toDate().toJSON();
                    }
                    else {
                        loanProductVM.minStartDate = loanProductVM.LoanProduct.EffectiveStartDate;
                    }
                    loanProductVM.minEndDate = loanProductVM.LoanProduct.EffectiveStartDate;
                    loanProductVM.LoanProduct.EffectiveStartDate = new Date(loanProductVM.LoanProduct.EffectiveStartDate);
                    loanProductVM.lookup.ProductTypes = LoanProductService.productTypes;
                    
                    loanProductVM.lookup.ProductClassifications = LoanProductService.ProductClassifications;
                }
                //#endregion

                (function InitializePage() {
                    HandleResolveData();
                    InitializeData();
                })();


            }]);//main controller function end
})();